import React from 'react';
import logoImg from '../../images/logo.png';

const IconLogo = () => (
  <img
    src={logoImg}
    alt="Logo"
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: '4px',
    }}
  />
);

export default IconLogo;
